import ic_conectate from "../../../static/img/icons/ic_conectate.svg";
import ic_facebook from "../../../static/img/icons/ic_facebook.svg";
import gender from "../../../static/img/icons/ic_gender.svg";
import ic_github from "../../../static/img/icons/ic_github.svg";
import ic_google from "../../../static/img/icons/ic_google.svg";
import ic_instagram from "../../../static/img/icons/ic_instagram.svg";
import ic_linkedin from "../../../static/img/icons/ic_linkedin.svg";
import ic_microsoft from "../../../static/img/icons/ic_microsoft.svg";
import ic_twitter from "../../../static/img/icons/ic_twitter.svg";
import ic_youtube from "../../../static/img/icons/ic_youtube.svg";
import ic_conectate_white from "../../../static/img/logo_white.svg";
export { value as ic_whatsapp } from "../../../static/img/icons/ic_whatsapp.svg";

export const icons = {
	ic_microsoft,
	ic_twitter: ic_twitter,
	ic_facebook: ic_facebook,
	ic_google: ic_google,
	ic_instagram: ic_instagram,
	ic_youtube: ic_youtube,
	ic_linkedin: ic_linkedin,
	ic_conectate: ic_conectate,
	ic_conectate_white: ic_conectate_white,
	ic_github: ic_github,
	gender: gender
};
